import styles from './Market.module.css';

import { Container, Row, Col } from 'react-bootstrap';
import img2 from '../../assets/imgs/img13.png';



export const Marketplace = () => {
  return (
       <div>
     <Container className={`${styles.section}`}>
            <Row className={`${styles.row}`}>
            <Col lg={6} sm={12} xs={12} md={6} className={`${styles.col1}`}>
                <div>
                    <h2 className={`${styles.free}`}>Marketplace</h2>
                    <p className={`${styles.desc}`}>Never loose files again, keep your web files, passwords, images, logos and contents
                      safe on your ULLWEB workspace.We created a marketplace for you, where you
                    could  earn, by selling your services to our
                    wide variety of users.</p>
                </div>
            </Col>

            <Col lg={6} sm={12} xs={12} md={6} className={`${styles.col2}`}>
            <div className={`${styles.imgcol}`}>
             <img src={img2} alt='service sectionimage' className={`${styles.img}`} />
             </div>
             </Col>
            </Row>
        </Container>
    </div>
  )
}
